export const drivnStyles = {
	header: {
		backgroundColor: '#231F20',
	},
	sidebar: {
		backgroundColor: '#231F20',
		color: 'white',
	},
	button: {
		backgroundColor: '#159BFF',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#4eb1fd',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#161616',
		buttonLoadingColor: '#159BFF',
	},
	table: {
		headerBackgroundColor: '#008ed8',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Drivn Platform',
	},
	logo: {
		small: {
			src: '/drivn/drivn-icon.png',
			height: 40,
			width: 45,
		},
		large: {
			src: '/drivn/drivn-logo.png',
			height: 43,
			width: 130,
		},
	},
	favicon: {
		src: '/drivn/drivn-icon.png',
	},
	socials: {},
	siteUrl: 'https://drivnparking.com/',
	orgName: 'Drivn Parking',
};
